
// Temporarily hide popup and sticky tab for future reuse
const EventPopupWidget = () => {
  // return null;
};

export default EventPopupWidget;
